import type { I18nFn } from '#/i18n/types/I18nFn';

export const SearchInternshipRefinement = {
  AREAS_OF_FOCUS: 'areasOfFocus',
  FUNCTIONS: 'functions',
  LOCALE: 'locale',
  LOCATION_TYPE: 'locationType',
  ORG_TYPE: 'orgType',
  PAYMENT: 'payment',
  RADIUS: 'radius',
  RECENCY: 'recency',
} as const;

export const SEARCH_INTERNSHIP_REFINEMENT_NAMES = Object.values(
  SearchInternshipRefinement,
);

export function SEARCH_INTERNSHIP_REFINEMENT_LABELS(i18n: I18nFn) {
  return {
    [SearchInternshipRefinement.AREAS_OF_FOCUS]: i18n('Cause Areas'),
    [SearchInternshipRefinement.FUNCTIONS]: i18n('Internship Function'),
    [SearchInternshipRefinement.LOCALE]: i18n('Listing Language'),
    [SearchInternshipRefinement.LOCATION_TYPE]: i18n('Location Type'),
    [SearchInternshipRefinement.ORG_TYPE]: i18n('Org Type'),
    [SearchInternshipRefinement.PAYMENT]: i18n('Payment'),
    [SearchInternshipRefinement.RADIUS]: i18n('Radius'),
    [SearchInternshipRefinement.RECENCY]: i18n('Recency'),
  } as Record<SearchInternshipRefinementType, string>;
}

export type SearchInternshipRefinementType =
  (typeof SearchInternshipRefinement)[keyof typeof SearchInternshipRefinement];
